module.exports = __webpack_public_path__ + "static/media/slider-gif1.ba1196ac.gif";